<template>
    <div
        ref="table"
        style="height: 100%; overflow-x: auto; position: relative;" class="vue-data-table"
        :class="{'scroll-always-visible': scrollAlwaysVisible, 'infinite-loading': canInfinitePagination, 'pagination-table': canPagination}"
>
        <v-data-table
                :items="list"
                style="border-bottom: 1px solid #ddd; border-left: 1px solid #ddd; border-radius: 2px; border-right: 1px solid #ddd;"
                :headers="tableHeaderManager.endHeaders"
                :search="search"
                :hide-default-footer="hideDefaultFooter"
                :loading="false"
                :single-expand="singleExpand"
                :show-expand="showExpand"
                :group-by="groupBy"
                :group-desc="groupDesc"
                :show-group-by="showGroupBy"
                :fixed-header="true"
                :height="undefined"
                :item-key="'model.' + itemKey"
                :hide-default-header="true"
                :show-select="showSelect"
                :single-select="singleSelect"
                :page="1"
                :items-per-page="99999"
                :item-class="item => itemClass && itemClass(item.model)"
                :disable-sort="disableSort"
                :value="model"
                :multi-sort="multiSort"
                :mobile-breakpoint="100"
                :sort-desc.sync="serverSideSort ? [] : innerSortDesc"
                :sort-by.sync="serverSideSort ? [] : innerSortBy"
                :options.sync="innerOptions"
                @current-items="updateCurrentItems"
                @input="onInput"
                @click:row="v => $emit('click:row', v.model)"
        >
            <!-- 부모의 slot 을 그대로 v-data-table 컴포넌트로 전달합니다.
            다만 아래에 정의된 slot은 해당 slot 을 따라갑니다. -->
            <template
                    v-for="(index, name) in $scopedSlots"
                    v-slot:[name]="data"
>
                <slot :name="name" v-bind="data" />
            </template>

            <template #header>
                <!-- 커스텀 헤더입니다. 기존 헤더는 display: none 처리 하였습니다. -->
                <thead class="v-data-table-header custom-header">
<tr v-for="(row) in tableHeaderManager.maxRowspan" :key="row">
<template v-for="(node, col) in tableHeaderManager.nodes">
                        <!-- 각 헤더에는 th-id 를 부여하여 tableHeaderManager에서 감시할 수 있도록 합니다. -->
                        <th v-if="1 === row && showSelect && node.raw.value === 'data-table-select'"
                            :key="col"
                            :rowspan="tableHeaderManager.maxRowspan"
                            class="pa-0"
                            style="width: 48px; max-width: 48px;"
                            :th-id="node.id"
                        >
                            <div class="checkbox-wrap" @click.stop>
                                <template v-if="!singleSelect">
                                    <input v-ripple="true" type="checkbox" :class="{'checked': isAllChecked, 'intermediate': isOneMoreChecked}"
                                           @click.stop.prevent="toggleModel"
>
                                </template>
                            </div>
<!--                            <vue-data-table-select-header-->
<!--                                    v-if="!singleSelect"-->
<!--                                    @click:uncheck-all="onClickUncheckAll"-->
<!--                                    :is-selected="model && model.length > 0"-->
<!--                            >-->
<!--                            </vue-data-table-select-header>-->
                        </th>

                        <th v-else-if="1 === row && showExpand && node.raw.isExpand"
                            :key="col"
                            :rowspan="tableHeaderManager.maxRowspan"
                            style="width: 48px; max-width: 48px;"
                            class="pa-0"
                            :th-id="node.id"
                        />

                        <th v-else-if="1 === row && showUtil && node.raw.isUtil"
                            :key="col"
                            :rowspan="tableHeaderManager.maxRowspan"
                            style="width: 30px; max-width: 30px;"
                            class="pa-0"
                            :th-id="node.id"
                        />

                        <th
                                v-else-if="row === node.deep"
                                :key="col"
                                :rowspan="node.rowspan"
                                :colspan="node.colspan"
                                :style="{width: node.raw.width + 'px',
                                        maxWidth: node.raw.width + 'px',
                                        minWidth: node.raw.width + 'px',
                                        top: node.elementObject.parentHeight + 'px',
                                    }"
                                class="text-center"
                                :th-id="node.id"
                                :class="{'sortable': node.raw.sortable !== false}"
                        >
                            <div class="item-th" :class="node.raw.headerClass"
                                 style="justify-content: center; margin: 0 auto;"
                                 :style="{maxWidth: node.raw.width + 'px'}"
                            >
                                <slot :name="'header.' + node.prefixRaw.value" v-bind="{ header: node.raw }">
                                    <span>{{ node.raw.text }}</span>
                                </slot>
                                <template
                                        v-if="disableSort !== true && node.raw.sortable !== false && !node.hasChildren"
>
                                    <!-- Single Sort 헤더 sorting 아이콘 정의 -->
                                    <template v-if="multiSort === false">
                                        <span
                                            :class="{'active': innerSortBy.length > 0
                                            && innerSortBy[0] === node.prefixRaw.value
                                            && innerSortDesc[0] === true}"
                                            class="cursor" @click.stop="sortDown(node.prefixRaw.value, node.raw.sortable !== false)"
>
                                            <i
                                               aria-hidden="true"
                                               class="v-icon notranslate v-data-table-header__icon mdi mdi-arrow-down theme--light"
                                               style="font-size: 18px;"
/>
                                        </span>
                                        <span
                                            :class="{'active': innerSortBy.length > 0
                                            && innerSortBy[0] === node.prefixRaw.value
                                            && (innerSortDesc[0] === false)}"
                                            class="cursor" @click.stop="sortUp(node.prefixRaw.value, node.raw.sortable !== false)"
>
                                            <i aria-hidden="true"
                                               class="v-icon notranslate v-data-table-header__icon mdi mdi-arrow-up theme--light"
                                               style="font-size: 18px;"
/>
                                        </span>
                                    </template>
                                </template>
                            </div>
                        </th>
                    </template>
                </tr>
                </thead>


                <!-- fixed-item 영역입니다. -->
                <thead v-if="showFixedItem" class="custom-header fixed-item-header">
                <tr class="fixed-item">
                    <slot name="fixed-item">
                        <template v-for="(node, index) in tableHeaderManager.endNodes">
                            <th
                                    :key="index"
                                    :style="{top: tableHeaderManager.headerHeight + 'px',}"
                            >
                                <div
                                        style="width: 100%; display: flex; flex-direction: row;"
                                        :style="{justifyContent: node.raw.align === 'center' ? 'center' :
                                                (node.raw.align === 'end' ? 'flex-end' : node.raw.align)}"
                                >
                                    <div
                                            style="display: flex; flex-direction: row;"
                                            :style="{maxWidth: node.raw.width + 'px',
                                            justifyContent: node.raw.align === 'center' ? 'center' :
                                                (node.raw.align === 'end' ? 'flex-end' : node.raw.align)}"
                                            :class="fixedItemHeadersSafe[node.prefixRaw.value] && fixedItemHeadersSafe[node.prefixRaw.value].class &&
                                        fixedItemHeadersSafe[node.prefixRaw.value].class()"
                                    >
                                        <slot :name="'fixed-item.' + node.raw.value"
                                              v-bind="{ header: fixedItemHeadersSafe[node.raw.value] }"
>
                                            {{
                                            fixedItemHeadersSafe[node.raw.value] &&
                                            fixedItemHeadersSafe[node.raw.value].read &&
                                            fixedItemHeadersSafe[node.raw.value].read()
                                            }}
                                        </slot>
                                    </div>
                                </div>
                            </th>
                        </template>
                    </slot>
                </tr>
                </thead>
            </template>


            <!-- item.[value] slot 영역입니다. -->
            <template v-for="(slot, columnIndex) in itemSlotNames" v-slot:[slot.wrappingSlotName]="{ item, header, value }">
                <div :key="columnIndex">
                    <template>
                        <!-- 유효한 폼타입이 아니면 렌더링 성능향상을 위해 디폴트로 컴포넌트 사용없이 렌더링 합니다. -->
                        <template v-if="!header.type || !getFormComponent(header.type)">
                            <!-- 상단 셀 설명 툴팁 -->
                            <template v-if="item.rendered && item.entered && item.mouseenterIndex === columnIndex">
                                <v-tooltip
                                    :disabled="!(((header.descriptionFunc && header.descriptionFunc(value, item.model)) || header.description) && (!header.disabled || !header.disabled(value, item.model)))"
                                    :activator="`#vue${vueDataTableId}row${item.index}colunm${columnIndex}`"
                                    top
>
                                    <!--                                    <template v-slot:activator="{on}">-->
                                    <!--                                        <div style="position: absolute; width: 100%; height: 100%" v-on="on"></div>-->
                                    <!--                                    </template>-->
                                    <div style="max-width: 400px;"
                                         v-html="header.description"
                                    />
                                </v-tooltip>

                                <v-tooltip
                                    :disabled="!(header.tooltip && header.tooltip(value, item.model))"
                                    :activator="`#vue${vueDataTableId}row${item.index}colunm${columnIndex}`"
                                    :left="header.tooltipAlign === 'left'" :right="header.tooltipAlign !== 'left'"
                                    :color="header.tooltipColor && header.tooltipColor(value, item.model)"
                                >
                                    <!--                                    <template v-slot:activator="{on: innerOn}">-->
                                    <!--                                        <div style="position: absolute; width: 100%; height: 100%" v-on="innerOn"></div>-->
                                    <!--                                    </template>-->
                                    <div
                                        v-if="header.tooltip" style="max-width: 400px;"
                                        v-html="header.tooltip(value, item.model)"
                                    />
                                </v-tooltip>
                                {{ forceMouseEnterNextTick(item) }}
                            </template>

                            <div
                                    v-if="item.rendered"
                                    :id="`vue${vueDataTableId}row${item.index}colunm${columnIndex}`"
                                    class="item--cell"
                                    :class="cellClass(header, value, item, columnIndex)"
                                    :style="{minWidth: header.width + 'px'
                                    , justifyContent: header.align === 'end' ? 'flex-end' : (header.align === 'center' ? 'center' : undefined)}"
                                    @mouseenter="onMouseEnterCell(item, header, value, columnIndex)"
                                    @mouseleave="onMouseLeaveCell(item, header, value, columnIndex)"
                                    @click="e => {
                                                if (header.disabled && header.disabled(value, item.model)) return;
                                                if (header.cellClicked) {
                                                    e.stopPropagation();
                                                    header.cellClicked(value, item.model);
                                                }
                                            }"
                            >
                                <div class="hint--mark" />
                                <div v-if="header.label" :class="header.label(value, item.model)" class="vue-data-table__label" />

                                <slot :name="slot.itemSlotName"
                                      v-bind="{ item: item.model, header: {...header, value: header.value.substring(6)}, value,
                                      enteredRow: item.entered, enteredCell: item.entered && item.mouseenterIndex === columnIndex,
                                      emptyObj: emptyObj[item.index][columnIndex] }"
>
                                    <div
                                            style="flex-grow: 1; display: flex; padding: 8px 8px; width: 100%; height: 100%; overflow: hidden;"
                                            :style="{
                                                            maxWidth: header.width + 'px',
                                                            justifyContent: header.align === 'end' ? 'flex-end' : (header.align === 'center' ? 'center' : undefined),
                                                            alignItems: header.vertical === 'end' ? 'flex-end' : (header.vertical === 'start' ? undefined : 'center'),
                                                     }"
                                    >
                                        <span v-if="!!header.read" v-html="(header.read(value, item.model) || '-')" />
                                        <span v-else-if="!!header.formatType" v-html="getTextFromItemFormatType(header, value)" />
                                        <span v-else v-html="(value || '-')" />
                                        <img v-if="header.src && header.src(value, item.model)"
                                             :src="header.src(value, item.model)"
                                             style="width: 20px; height: 20px; margin-left: 3px;"
>
                                        <template v-if="header.images && header.images.length > 0">
                                            <template v-for="(image, index) in header.images">
                                                <img
                                                        v-if="image.src(value, item.model)"
                                                        :key="index"
                                                        :src="image.src(value, item.model)"
                                                        style="width: 20px; height: 20px; margin-left: 3px;"
>
                                            </template>
                                        </template>
                                        <template v-if="header.icons && header.icons.length > 0">
                                            <div style="flex-grow: 1" />
                                            <div class="icon--container" :style="{minWidth: header.icons.length * 38 + 'px'}">
                                                <template v-if="item.entered">
                                                    <v-btn v-for="(icon, index) in header.icons" :key="index" icon @click.stop="icon.click(value, item.model)">
                                                        <img v-if="icon.icon" :src="icon.icon">
                                                    </v-btn>
                                                </template>
                                            </div>
                                        </template>
                                    </div>
                                </slot>
                            </div>
                        </template>
                    </template>
                </div>
            </template>
            <!-- item.[value] slot 끝 -->

            <!-- data-table-select slot -->
            <template #item.data-table-select="{ item, isSelected, select }">
                <!-- 기능성 심플 체크박스 v-data-table 과 연동되어 작동합니다. -->
                    <div class="checkbox-wrap" @click.stop>
                        <template v-if="!singleSelect">
                            <input v-ripple="true" type="checkbox" :class="{'checked': isSelected}"
                                   @click.stop.prevent="() => select(isSelected ? false : true)"
>
                        </template>
                    </div>
<!--                    <div class="vue-data-table-select" v-if="!singleSelect">-->
<!--                        <div class="checkbox_wrap directional-transition"-->
<!--                             @click.stop.prevent-->
<!--                        >-->
<!--                            &lt;!&ndash; 기능성 심플 체크박스 v-data-table 과 연동되어 작동합니다. &ndash;&gt;-->
<!--                            <input v-ripple="true" type="checkbox" :class="{'checked': isSelected}"-->
<!--                                   @click.stop.prevent="() => select(isSelected ? false : true)">-->
<!--                        </div>-->
<!--                    </div>-->
            </template>


            <!-- data-table-util slot -->
            <template #item.data-table-util="{ item, header, value }">
                <vue-data-table-util-item>
                    <vue-data-table-icons
                            v-if="!isEmpty(header.icons)"
                            :icons="header.icons"
                            :item="item"
                            :header="header"
                            :value="value"
                            :always-show="true"
                    />
                </vue-data-table-util-item>
            </template>

            <!-- expanded-item slot -->
            <template #expanded-item="{ item, headers }">
                <slot name="expanded-item" v-bind="{ item, headers, colspan: tableHeaderManager.maxColspan }" />
            </template>


            <!-- body.append slot -->
            <template #body.append>
                <!-- v-data-table's slot -->
                <slot v-slot:body.append />

                <!-- vue infinite loading -->
                <tr v-if="canInfinitePagination">
                    <td :colspan="tableHeaderManager.maxColspan">
                        <infinite-loading :identifier="infiniteId" @infinite="infiniteHandler" />
                    </td>
                </tr>
            </template>

            <!-- footer slot -->
            <template #footer>
                <div v-if="canPagination"
                     style="display: flex; justify-content: center; width: 100%;"
>
                    <vue-data-table-pagination
                            v-model="ipage"
                            :total-count="totalCount"
                            :items-per-page="+itemsPerPage"
                            :total-visible="totalVisible"
                            :loading="loadingComputed"
                            :identifier="clearIdentifier"
                            :prev-button-text="prevButtonText"
                            :next-button-text="nextButtonText"
                            :disabled="innerDisabled || disabled"
                            @paging="goPaging"
                            @init="initPagination"
                            @update:total-count-of-page="v => totalCountOfPage = v"
                    />
                </div>
            </template>
        </v-data-table>
        <div v-show="!loadingComputed && list.length === 0" v-if="canPagination" class="nodata_wrap">
            <div class="nodata_text">
{{ noDataText }}
</div>
        </div>
        <div v-show="loadingComputed" v-if="canPagination" class="loading_wrap">
            <div class="loading" />
            <div class="loading" />
            <div class="loading" />
        </div>
    </div>
</template>

<script>
    import VDataTableProps from "./VDataTableProps";
    import VueInfiniteLoadingHelper from "./VueInfiniteLoadingHelper";
    import VueDataTableFunctions from "./VueDataTableFunctions";
    import VueDataTableIcons from "./components/VueDataTableIcons";
    import VueDataTableUtilItem from "./components/VueDataTableUtilItem";
    import VueDataTableFormProvider from "./vue-data-table-form-provider";
    import {VUE_DATA_TABLE_TYPE} from "./vue-data-table-form-types";
    import {numberHelper} from "@/assets/plugins/mps-common/formatters/number-helper";
    import {dateHelper} from "@/assets/plugins/mps-common/time/date-helper";
    import VuePaginationHelper from "@/assets/plugins/vue-data-table/VuePaginationHelper";
    import VueDataTablePagination from "@/assets/plugins/vue-data-table/components/VueDataTablePagination";

    /**
     * fixed 헤더의 옵션을 제거하고 항상 fixed header 상태를 유지합니다.
     * VueDataTable 컴포넌트를 감싸고 있는 컨테이너의 height 가 고정 px 이라면 fixed-height
     * height 가 지정되지 않았다면 헤더가 고정되지 않는 테이블입니다.
     */
    export default {
        name: "VueDataTable",
        components: {
            VueDataTablePagination,
            VueDataTableUtilItem, VueDataTableIcons
        },
        mixins: [
            /** vue-data-table 을 구성하는데  필요한 기능성 함수 모음입니다. */
            VueDataTableFunctions,
            /** v-data-table 의 props 속성을 그대로 가져옵니다. */
            VDataTableProps,
            /** vue-infinite-loading 을 하기위한 믹스인입니다. */
            VueInfiniteLoadingHelper,
            /** vue-pagination 을 하기위한 믹스인입니다. */
            VuePaginationHelper,
        ],
        props: {
            noEvent: {
                type: Boolean,
                default: false,
            },
            moveTo: undefined,
            hintClass: {
                type: [String],
                default: undefined,
            },
            disabled: {
                type: Boolean,
                default: false,
            },
            provider: {
                type: String,
                default: "form",
            },
            serverSideSort: {
                type: Boolean,
                default: false,
            },
            scrollAlwaysVisible: {
                type: Boolean,
                default: false,
            },
            /**
             * 페이지네이션을 위한 콜백 메소드입니다.
             * params: page:Number, itemsPerPage:Number, sortBy:Array, sortDesc:Array
             */
            fetch: {
                type: Function,
                default: undefined,
            },
            infinitePagination: {
                type: Boolean,
                default: false,
            },
            fetchCount: {
                type: Function,
                default: undefined,
            },
            totalVisible: {
                type: Number,
                default: 10,
            },
            /**
             * identifier 가 변경되면 페이징이 초기화 됩니다.
             */
            identifier: {
                type: Number,
                default: 0,
            },
            /**
             * reload 가 변경되면 현재 페이지의 목록을 리로드합니다.
             */
            reload: {
                type: Number,
                default: 0,
            },
            checkValidOrder: {
                type: Function,
                default: undefined,
            },
            useVirtualScroll: {
                type: Boolean,
                default: false,
            },
            prevButtonText: {
                type: String,
                default: 'Prev',
            },
            nextButtonText: {
                type: String,
                default: 'Next',
            },
        },
        data() {
            return {
                innerOptions: {},
                emptyObj: [],
                formProvider: new VueDataTableFormProvider(this.provider),

                // Sorting
                innerSortDesc: [],
                innerSortBy: [],

                // 페이지 네이션 헬퍼에서 사용하는 반응성 변수입니다.
                ipage: 1, // 페이지네이션을 위한 내부 페이지 값입니다.
                list: [], // 리스트를 위한 내부 리스트 입니다. // 성능 향상을 위해 목록을 wrapper 클래스로 한 번 감쌉니다.

                // 페이지네이션 변수입니다.
                totalCount: 0,
                totalCountOfPage: 0,

                // 목록이 초기화 되면 이 값은 변경됩니다.
                clearIdentifier: 0,

                // 현재 스크롤 되고 있는지 여부를 가리킴
                scrolling: false,

                // tr 용 mouseenter, mouseleave 시 렉 걸리는 현상을 없애기 위한 타이머를 임시로 저장하는 변수
                trLazyEnterTimer: null,
                trLazyLeaveTimer: null,

                // td 용 mouseenter, mouseleave 시 렉 걸리는 현상을 없애기 위한 타이머를 임시로 저장하는 변수
                tdLazyEnterTimer: null,
                tdLazyLeaveTimer: null,

                innerDisabled: false,

                scrollableContainer: null,

                currentItems: [],

                listUpdated: false,
                vueDataTableId: this.$vueDataTableId++,
            };
        },
        computed: {
            /**
             * 서버사이드 정렬 기능을 사용하는지 여부입니다.
             *
             * 서버사이드 정렬 기능을 사용하더라도 한 페이지에 모든 목록이 노출되었다고 판단되는 경우
             *
             * v-data-table 의 내부 정렬 기능을 사용합니다.
             */
            serverSideSortComputed() {
                // return this.serverSideSort
                //     && ((this.canPagination && this.totalCountOfPage > 1) || (this.canInfinitePagination && this.infiniteStatus === 2));
                return this.serverSideSort;
            },

            loadingComputed() {
                return this.infiniteLoading || this.loading || this.pagingLoading;
            },

            innerSortByComputed() {
                if (!this.innerSortBy) return [];
                return this.innerSortBy.map(e => e.substring(6));
            },

            lastIndex() {
                return this.list.length - 1;
            },
        },
        watch: {
            /**
             * 테이블에서 moveTo에 해당하는 아이템 키를 찾아 화면상에 노출되게 상단으로 옮깁니다.
             */
            moveTo() {
                if (!this.$refs.table) return;
                // 기존의 힌트 클래스가 있다면 모두 지웁니다.
                if (this.hintClass) {
                    const allTrs = this.$refs.table.querySelectorAll("tbody tr");
                    if (!allTrs || allTrs.length === 0) return;
                    const type = typeof this.hintClass;
                    switch (type) {
                        // string 은 단일 클래스만 지원
                        case "string":
                            allTrs.forEach(e => {
                                e.classList.remove(this.hintClass);
                            });
                            break;
                        default:
                            break;
                    }
                }
                // 해당하는 위치로 스크롤합니다.
                if (this.moveTo) {
                    const target = this.$refs.table.querySelector(`.${this.rowClass(this.moveTo)}`);
                    const wrapper = this.scrollableContainer;
                    let top = target.offsetTop;
                    top = top < 0 ? 0 : top - target.clientHeight;
                    top = top > wrapper.scrollHeight ? wrapper.scrollHeight : top;
                    wrapper.scrollTo({top: top});
                    // 힌트 클래스가 있다면 힌트 클래스를 tr에 추가합니다.
                    if (this.hintClass) {
                        const type = typeof this.hintClass;
                        switch (type) {
                            // string 은 단일 클래스만 지원
                            case "string":
                                this.$nextTick(() => {
                                    target.classList.add(this.hintClass);
                                });
                                break;
                            default:
                                break;
                        }
                    }
                }
            },

            loadingComputed() {
                this.$emit('update:loading', this.loadingComputed);
            },

            sortBy() {
                if (this.equalsSortBy()) return; // 같은 배열입니다.
                this.updateSortBy();
            },

            sortDesc() {
                this.updateSortDesc();
            },

            innerSortBy() {
                this.$emit('update:sort-by', this.innerSortByComputed);
                if (this.serverSideSortComputed) { // 서버 사이드 sort 이면 목록을 초기화합니다.
                    if (this.disabled) return;
                    this.clear();
                } else {
                    this.scrollToTop();
                }
            },

            innerSortDesc() {
                this.$emit('update:sort-desc', this.innerSortDesc);
                if (this.serverSideSortComputed) { // 서버 사이드 sort 이면 목록을 초기화합니다.
                    if (this.disabled) return;
                    this.clear();
                }
            },

            items() {
                this.list = this.wrap(this.items);
            },

            list() {
                this.listUpdated = true;
                if (this.list.length === 0) return;
                this.createEmptyObj();
                // 각각의 아이템마다 index를 부여합니다.
                for (let i = 0; i < this.list.length; i++) {
                    this.list[i].index = i;
                }
            },

            /**
             * v-data-table 의 내부 정렬, 필터에 의해 나온 아이템 목록입니다.
             */
            currentItems(newValue) {
                // 리스트가 변경된 경우에만 실행합니다.
                if (!this.noEvent && this.listUpdated) {
                    this.listUpdated = false;
                    // 정렬된 항목에 대해 스크롤 이벤트 등록
                    this.registerTrEvent(this.currentItems);
                }
                if (this.useVirtualScroll) this.calculateRender(49);
            },

            identifier() {
                this.clear();
            },

            itemsPerPage() {
                this.clear();
            },

            reload() {
                if (this.canPagination) {
                    this.goPaging(this.ipage, this.itemsPerPage, this.innerSortBy, this.innerSortDesc);
                }
            },
        },
        created() {
            if (this.$isNotEmpty(this.items)) this.list = this.wrap(this.items);
            this.createEmptyObj();
            this.updateSortBy();
            this.updateSortDesc();
        },
        mounted() {
            // 자식이 존재하면 헤더 감시 시작
            if (this.tableHeaderManager.maxRowspan > 1) {
                this.tableHeaderManager.observe();
            }

            if (!this.$refs.table) return;
            this.scrollableContainer = this.$refs.table.querySelector('.v-data-table__wrapper');
            if (!this.scrollableContainer) {
                setTimeout(() => {
                    this.registerScrollEvent();
                }, 500);
                return;
            } else {
                this.registerScrollEvent();
            }
            if (this.useVirtualScroll) this.calculateRender(49);
        },
        methods: {
            pushItems(items) {
                this.list.push(...this.wrap(items));
            },

            updateSortBy() {
                let sortBy = this.sortBy;
                if (typeof this.sortBy === 'string') {
                    sortBy = [this.sortBy];
                } else {
                    this.scrollToTop();
                }
                if (!sortBy) return;
                this.innerSortBy = sortBy.map(e => 'model.' + e);
            },

            updateSortDesc() {
                let sortDesc = this.sortDesc;
                if (typeof this.sortDesc === 'boolean') {
                    sortDesc = [this.sortDesc];
                }
                this.innerSortDesc = sortDesc;
            },

            /**
             * 화면상에 렌더링 되는 영역을 계산하여 인덱스로 치환합니다.
             */
            calculateRender(trHeight = 49) {
                if (this.$isEmpty(this.currentItems)) return;
                // 현재 화면상에 보이는 영역을 계산하여 보이지 않는 영역은 렌더링을 하지 않습니다.
                let startIndex = (this.scrollableContainer.scrollTop / trHeight) - 3;
                let endIndex = ((this.scrollableContainer.clientHeight + this.scrollableContainer.scrollTop) / trHeight) + 3;
                startIndex = startIndex < 0 ? 0 : startIndex;
                endIndex = endIndex > this.lastIndex ? this.lastIndex : endIndex;
                for (let i = 0; i < this.currentItems.length; i++) {
                    const item = this.currentItems[i];
                    if (i >= startIndex && i <= endIndex) item.rendered = true;
                    else item.rendered = false;
                }
            },

            forceMouseEnterNextTick(item) {
                if (this.noEvent) return;
                if (item.mouseenterIndex === -1) return;
                if (!item.entered) return;
                if (item.columnMouseEnterForce) return;
                item.columnMouseEnterForce = true;
                setTimeout(() => {
                    const target = this.$refs.table.querySelector(`#vue${this.vueDataTableId}row${item.index}colunm${item.mouseenterIndex}`);
                    if (!target) return;
                    let event = new MouseEvent('mouseenter', {
                        'view': window,
                        'bubbles': false,
                        'cancelable': false
                    });
                    target.dispatchEvent(event);
                }, 30);
            },

            getValueOfItem(o, s) {
                if (!o) return null;
                if (!s) return null;
                s = s.replace(/\[(\w+)\]/g, '.$1'); // convert indexes to properties
                s = s.replace(/^\./, '');           // strip a leading dot
                let a = s.split('.');
                for (let i = 0, n = a.length; i < n; ++i) {
                    let k = a[i];
                    if (k in o) {
                        o = o[k];
                    } else {
                        return null;
                    }
                }
                return o;
            },

            rowClass(value) {
                return `vue${this.vueDataTableId}-row-${value}`;
            },

            registerScrollEvent() {
                this.scrollableContainer = this.$refs.table.querySelector('.v-data-table__wrapper');
                if (!this.scrollableContainer) return;
                let stopTimer = null;

                this.scrollableContainer.addEventListener('scroll', _.throttle(e => {
                    this.scrolling = true;
                    clearTimeout(stopTimer);
                    stopTimer = setTimeout(() => {
                        this.scrolling = false;
                        if (this.useVirtualScroll) this.calculateRender(49);
                    }, 350);
                }, 300), {passive: true});
            },

            registerTrEvent(items) {
                if (this.noEvent) return;
                if (!items) return;
                this.$nextTick(() => {
                    if (!this.$refs.table) return;
                    const trs = this.$refs.table.querySelectorAll('table tbody tr');
                    let index = 0;
                    trs.forEach(tr => {
                        const item = items[index];
                        const val = this.getValueOfItem(item, 'model.' + this.itemKey);
                        if (!val) return;
                        tr.classList.add(this.rowClass(val));
                        tr.addEventListener('mouseenter', e => {
                            if (this.trLazyEnterTimer != null) {
                                clearTimeout(this.trLazyEnterTimer);
                                this.trLazyEnterTimer = null;
                            }
                            item.rowEntered = true;
                            this.trLazyEnterTimer = setTimeout(() => {
                                const interval = setInterval(() => {
                                    if (!item.rowEntered) {
                                        clearInterval(interval);
                                        return;
                                    }
                                    if (this.scrolling) {
                                        return;
                                    }
                                    item.entered = true;
                                    this.$emit('mouseenter:row', item.model);
                                    clearInterval(interval);
                                }, 100);
                            }, 150);
                        });
                        tr.addEventListener('mouseleave', e => {
                            if (!item.rowEntered) return;
                            item.rowEntered = false;
                            if (this.scrolling) return;
                            if (this.trLazyLeaveTimer != null) {
                                clearTimeout(this.trLazyLeaveTimer);
                                this.trLazyLeaveTimer = null;
                            }
                            this.trLazyLeaveTimer = setTimeout(() => {
                                item.entered = false;
                                this.$emit('mouseleave:row', item.model);
                            }, 200);
                        });
                        index++;
                    });
                });
            },

            onMouseEnterCell(item, header, value, index) {
                if (this.noEvent) return;
                if (this.tdLazyEnterTimer != null) {
                    clearTimeout(this.tdLazyEnterTimer);
                    this.tdLazyEnterTimer = null;
                }
                item.columnEntered = true;
                this.tdLazyEnterTimer = setTimeout(() => {
                    if (!item.columnEntered) return;
                    const interval = setInterval(() => {
                        if (!item.columnEntered) {
                            clearInterval(interval);
                            return;
                        }
                        if (this.scrolling) {
                            return;
                        }
                        item.mouseenterIndex = index;
                        header.mouseenter && header.mouseenter(value, item.model);
                        clearInterval(interval);
                    }, 150);
                }, 150);
            },

            onMouseLeaveCell(item, header, value, index) {
                if (this.noEvent) return;
                if (!item.columnEntered) return;
                item.columnEntered = false;
                item.columnMouseEnterForce = false;
                if (item.mouseenterIndex > -1) {
                    item.mouseenterIndex = -1;
                    header.mouseleave && header.mouseleave(value, item.model);
                }
            },

            /**
             * 렌더링 최적화를 위해서 내부적으로 model.이라는 접두사를 이용해
             * 원본 아이템에 접근할 수 있습니다. 외부에서는 몰라도 되므로 내부의 접두사가 붙은 model 목록과
             * 외부의 원본 목록을 v-model 로 구현할 수 있도록, 두 배열을 비교하는 함수를 사용합니다.
             */
            equalsSortBy() {
                let sortBy = this.sortBy;
                if (typeof sortBy === 'string') {
                    sortBy = [this.sortBy];
                }
                if (!this.innerSortBy && !sortBy) return true;
                if (this.innerSortBy && !sortBy) return false;
                if (!this.innerSortBy && sortBy) return false;
                return _.isEqual(this.innerSortByComputed, sortBy);
            },

            /**
             * 외부 클래스를 이용하면 반응성이 없습니다.
             */
            wrap(items) {
                if (!items) return [];
                return items.map(e => {
                    const obj = {};
                    this.$set(obj, "model", e);
                    this.$set(obj, "entered", false);
                    this.$set(obj, "mouseenterIndex", -1);
                    this.$set(obj, "index", -1);
                    this.$set(obj, "columnEntered", false);
                    this.$set(obj, "rowEntered", false);
                    this.$set(obj, "columnMouseEnterForce", false);
                    this.$set(obj, "rendered", this.useVirtualScroll ? false : true);
                    return obj;
                });
            },

            /**
             * 테이블의 스크롤을 Top: 0 으로 합니다.
             */
            scrollToTop() {
                if (!this.$refs.table) return;
                const wrapper = this.$refs.table.querySelector(".v-data-table__wrapper");
                wrapper.scroll({top: 0});
            },

            /**
             * 슬랏 외부에서 연산작업에 사용할 빈 오브젝트를 생성합니다.
             */
            createEmptyObj() {
                this.emptyObj = [];
                this.list.forEach(() => {
                    const arr = [];
                    for (let i = 0; i < this.tableHeaderManager.maxColspan; i++) {
                        arr.push({});
                    }
                    this.emptyObj.push(arr);
                });
            },

            /**
             * 헤더 데이터를 기반으로 item cell 에 적용될 class 문자열을 생성해 반환합니다.
             */
            cellClass(header, value, item, index) {
                let clazz = 'vue-data-table__tooltip__container';
                clazz += ` item--cell--${item.index}--${index}`;
                if (header.cellClicked && (!header.disabled || !header.disabled(value, item.model))) clazz += ' hint--cell';
                if (header.itemClass) clazz += " " + header.itemClass(value, item.model);
                return clazz;
            },

            /**
             * Type 에 해당하는 컴포넌트를 로드합니다.
             */
            getFormComponent(type) {
                if (!type) return null;
                let found = false;
                Object.keys(VUE_DATA_TABLE_TYPE).forEach(key => {
                    if (type === VUE_DATA_TABLE_TYPE[key]) found = true;
                });
                if (!found) {
                    return this.formProvider.getElement(VUE_DATA_TABLE_TYPE.TEXT);
                } else {
                    return null;
                }
            },

            /**
             * Format Type 에 맞추어 value 를 string 으로 변환합니다.
             */
            getTextFromItemFormatType(header, value) {
                let text = value && value.toString();
                if (header.formatType === 'currency') {
                    if (!value) text = '-';
                    else text = numberHelper.formatCurrency(value);
                } else if (header.formatType === 'number') {
                    if (!value) text = '-';
                    else text = numberHelper.formatNumber(value);
                } else if (header.formatType === 'datetime') {
                    if (!value) text = '-';
                    else text = dateHelper.formatDateTime(value);
                } else if (header.formatType === 'date') {
                    if (!value) text = '-';
                    else text = dateHelper.formatDate(value);
                } else if (header.formatType === 'month') {
                    if (!value) text = '-';
                    else text = dateHelper.formatMonth(value);
                }
                return text;
            },

            /**
             * 내부 목록 관련 데이터를 초기화합니다.
             */
            clear() {
                if (!this.fetch) return;
                this.clearIdentifier++;
                // 숫자기반 페이지네이션 초기화
                if (this.canInfinitePagination) {
                    this.changeType();
                }
                this.model = [];
            },

            /*******************************************************************************************
             * 헤더를 커스텀하였기 때문에 v-data-table 의 기본으로 제공되는 헤더는 사용되지 않습니다.
             * 따라서 v-data-table 의 sorting 기능을 그대로 활용하기 위해 몇 가지 메소드를 구현하였습니다.
             *******************************************************************************************/

            sortUp(value, sortable) {
                if (this.loadingComputed) return; // 로딩중이면 리턴
                if (!sortable) return;
                let desc = [];
                let by = [];
                // 이미 업 정렬이 되어 있으면 정렬해제
                if (this.innerSortBy.length === 1 && this.innerSortBy[0] === value && this.innerSortDesc[0] === false) {
                } else {
                    desc = [false];
                    by = [value];
                }

                // 후위 계산
                if (!!this.checkValidOrder && !this.checkValidOrder(by.map(e => e.substring(6)), desc)) {
                    return; // 정렬이 불가능하다면 리턴
                }

                this.innerSortBy = by;
                this.innerSortDesc = desc;
            },

            sortDown(value, sortable) {
                if (this.loadingComputed) return; // 로딩중이면 리턴
                if (!sortable) return;
                let desc = [];
                let by = [];
                // 이미 다운 정렬이 되어 있으면 정렬해제
                if (this.innerSortBy.length === 1 && this.innerSortBy[0] === value && this.innerSortDesc[0] === true) {
                } else {
                    desc = [true];
                    by = [value];
                }

                // 후위 계산
                if (!!this.checkValidOrder && !this.checkValidOrder(by.map(e => e.substring(6)), desc)) {
                    return; // 정렬이 불가능하다면 리턴
                }

                this.innerSortBy = by;
                this.innerSortDesc = desc;
            },

        }
    }
</script>

<style scoped>
    .v-data-table {
        height: 100%;
    }

    /* fixed header 를 위한 세팅 */
    .pagination-table .v-data-table {
        height: calc(100% - 43.6px);
    }

    .v-data-table.infinite-loading {
        height: 100%;
    }

    >>> .v-data-table__wrapper {
        height: 100%;
    }

    /* fixed header 를 위한 세팅 끝 */


    /* header design */
    .v-data-table > .v-data-table__wrapper > table > thead > tr > th {
        border-right: 1px solid #ddd;
    }

    .v-data-table > .v-data-table__wrapper > table > thead tr > th:last-child {
    }

    .v-data-table > .v-data-table__wrapper > table > thead tr > th {
        background-color: #f8f8f8;
    }

    .v-data-table > .v-data-table__wrapper > table > tbody > tr > td {
        border-right: 1px solid #ddd;
        padding: 0;
    }

    /* header design 끝 */


    /* th style */
    .item-th {
        display: flex;
        width: 100%;
        color: #333;
    }

    /* th style 끝*/


    /* td style */
    .v-data-table > .v-data-table__wrapper > table > tbody > tr > td {
        border-right: 1px solid #ddd;
    }

    >>> .v-data-table > .v-data-table__wrapper > table > tbody > tr > td {
        padding: 0 !important;
    }

    /* td style 끝*/


    /*text 말줄임표 스타일*/
    /*text 말줄임표 스타일 끝*/


    /*text 줄바꿈 스타일*/

    /* text 줄바꿈 스타일 끝 */


    /* Infinite Loading 스타일 */
    >>> .infinite-status-prompt:nth-child(2),
    >>> .infinite-status-prompt:nth-child(3) {
        width: 150px;
        height: 35px;
        line-height: 1;
        margin: 20px auto;
        border-radius: 150px;
        background-color: #2b3f54;
        color: white !important;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    >>> .infinite-status-prompt .loading-default:before {
        /*background-color: white !important;*/
    }

    /* Infinite Loading 스타일 끝 */


    /* 테이블 헤더 공용 스타일링 */
    .v-data-table > .v-data-table__wrapper > table > thead > tr > th {
        padding: 8px 8px;
    }

    /* 테이블 헤더 공용 스타일링 */

    /* fixed-item slot header 스타일 시작 */
    .v-data-table > .v-data-table__wrapper > table > thead.fixed-item-header {
        font-size: 0.875rem !important;
    }

    .v-data-table > .v-data-table__wrapper > table > thead.fixed-item-header > tr > th {
        font-size: 0.875rem !important;
        position: sticky;
    }

    .v-data-table > .v-data-table__wrapper > table > thead.fixed-item-header tr > th {
        background: white;
        height: auto;
    }

    .v-data-table > .v-data-table__wrapper > table > thead.fixed-item-header > tr > th {
        background-color: white !important;
    }

    .v-data-table > .v-data-table__wrapper > table > thead.fixed-item-header > tr > th {
        border-bottom: 1px solid #888 !important;
        border-top: 1px solid #888 !important;
    }

    .v-data-table > .v-data-table__wrapper > table > thead .custom-header tr > th {
        border-top: 1px solid #ddd !important;
    }

    .v-data-table {
        border-top: 1px solid #ddd !important;
    }

    /* fixed-item slot header 스타일 끝 */

    .vue-data-table >>> table > tbody > tr > td {
        height: 48px;
    }

    /* item cell */
    .item--cell {
        display: flex;
        flex-direction: row;
        justify-content: stretch;
        align-items: center;
        padding: 0;
        height: 48px;
        position: relative;
        overflow: hidden;
    }

    /* hint cell */
    .hint--cell:hover {
        background-color: #F8F5FF;
        cursor: pointer;
    }

    >>> .hint--cell * {
        cursor: pointer;
    }

    .hint--mark {
        visibility: hidden;
        position: absolute;
    }

    tr .item--cell.hint--cell > .hint--mark {
        right: -3px;
        top: 0;
        width: 0;
        height: 0;
        border-left: 5px solid transparent;
        border-right: 5px solid transparent;
        border-bottom: 5px solid #6852B5;
        transform: rotate(45deg);
    }

    tr:hover .item--cell.hint--cell > .hint--mark {
        visibility: visible;
    }

    /* tooltip */
    .vue-data-table__tooltip {
        position: absolute;
        top: 0;
        left: 50%;
        visibility: hidden;
        min-width: 120px;
        max-width: 200px;
        font-weight: normal !important;
    }

    .vue-data-table__toolip__box {
        position: relative;
        left: -50%;
        text-align: center;
        display: flex;
        justify-content: center;
    }

    .vue-data-table__toolip__text__calc {
        padding: 4px 8px;
        visibility: hidden;
        text-align: center;
    }

    .vue-data-table__toolip__text {
        text-align: center;
        padding: 4px 8px;
        pointer-events: none;
        visibility: hidden;
    }

    .vue-data-table__tooltip.tooltip-left,
    .vue-data-table__tooltip.tooltip-right {
        min-width: 200px;
    }

    .vue-data-table__tooltip .vue-data-table__toolip__text,
    .vue-data-table__tooltip .vue-data-table__toolip__text__calc {
        min-width: 100px;
    }

    .vue-data-table__tooltip .vue-data-table__toolip__text {
        position: absolute;
        top: calc(-100% - 4px);
        z-index: 9;
        border-radius: 4px;
        background: #555555;
        color: white;
        pointer-events: none;
        opacity: 0;
        visibility: hidden;
        transform: scale(0);
        transition-delay: 0s;
        transition: opacity .2s, transform .2s ease-out;
        overflow: hidden;
        word-break: break-all;
    }

    .vue-data-table__tooltip__container.hint--cell:hover > .vue-data-table__tooltip .vue-data-table__toolip__text,
    .vue-data-table__tooltip__container:hover > .vue-data-table__tooltip.tooltip-left .vue-data-table__toolip__text,
    .vue-data-table__tooltip__container:hover > .vue-data-table__tooltip.tooltip-right .vue-data-table__toolip__text {
        visibility: visible;
        transform: scale(1);
        opacity: .9;
        transition-delay: .6s;
    }

    .vue-data-table__toolip__text__calc:empty {
        display: none !important;
    }

    .vue-data-table__toolip__text:empty {
        display: none !important;
    }

    /* right tooltip */
    .vue-data-table__tooltip.tooltip-right {
        top: 50%;
        left: 100%;
    }

    .vue-data-table__tooltip.tooltip-right > .vue-data-table__toolip__box {
        top: 0;
        left: 0;
    }

    .vue-data-table__tooltip.tooltip-right > .vue-data-table__toolip__box > .vue-data-table__toolip__text {
        top: -50%;
        left: 4px;
    }

    /* left tooltip */
    .vue-data-table__tooltip.tooltip-left {
        top: 50%;
        left: 0;
    }

    .vue-data-table__tooltip.tooltip-left > .vue-data-table__toolip__box {
        top: 0;
        left: -100%
    }

    .vue-data-table__tooltip.tooltip-left > .vue-data-table__toolip__box > .vue-data-table__toolip__text {
        top: -50%;
        right: 4px;
    }

    .vue-data-table__tooltip__container:hover > .vue-data-table__tooltip.tooltip-right .vue-data-table__toolip__text,
    .vue-data-table__tooltip__container:hover > .vue-data-table__tooltip.tooltip-left .vue-data-table__toolip__text {
        transition-delay: .2s;
    }

    .v-tooltip__content {
        max-width: 400px;
    }

    .v-tooltip__content:empty {
        display: none !important;
    }

    th:not(.sortable) {
        cursor: default !important;
    }

    th.sortable {
        cursor: pointer !important;
    }

    .scroll-always-visible >>> .v-data-table__wrapper {
        overflow-y: scroll !important;
    }

    /* 데이터 없음 스타일 시작 */
    .nodata_wrap {
        position: absolute;
        width: 100%;
        height: 100%;
        top: 0;
        right: 0;
        left: 0;
        bottom: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        z-index: 1;
    }

    .nodata_text {
        color: #ccc;
        font-weight: bold;
        font-size: 14px;
    }

    /* 데이터 없음 스타일 종료 */

    /* 로딩 아이콘 시작 */
    .loading_wrap {
        position: absolute;
        width: 100%;
        height: 100%;
        top: 0;
        right: 0;
        left: 0;
        bottom: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        z-index: 999;
    }

    .loading {
        width: 8px;
        height: 8px;
        background: #aaaaaa;
        border-radius: 50%;
        animation: loading-cricle 1.5s infinite ease-in-out;
        display: inline-block;
        margin-right: 8px;
    }

    .loading:nth-child(2) {
        animation-delay: .5s;
    }

    .loading:nth-child(3) {
        animation-delay: 1s;
    }

    @keyframes loading-cricle {
        0% {
            opacity: .4;
            transform: scale(1, 1);
        }
        50% {
            opacity: 1;
            transform: scale(1.2, 1.2);
        }
        100% {
            opacity: .4;
            transform: scale(1, 1);
        }
    }

    .v-data-table__empty-wrapper {
        display: none;
    }

    >>> .v-data-table__empty-wrapper {
        display: none;
    }
    /* 로딩 아이콘 끝 */

    >>> tr:last-child td {
        border-bottom: 1px solid #ddd;
    }

    /** 셀렉트 체크박스 Style 시작 */
    >>> .checkbox-wrap {
        display: flex; justify-content: center; align-items: center; width: 48px; max-width: 48px; height: 100%;
    }

    >>> input[type=checkbox] {
        display: inline-block !important;
        position: relative;
        cursor: pointer;
    }

    >>> input[type=checkbox]:before {
        content: "";
        display: block;
        position: absolute;
        width: 20px;
        height: 20px;
        top: -4px;
        left: -4px;
        border: 2px solid #555555;
        border-radius: 3px;
        background-color: white;
    }

    >>> input[type=checkbox].checked:before {
        border: 2px solid #0C98FE;
    }

    >>> input[type=checkbox].checked:after {
        content: "";
        display: block;
        width: 6px;
        height: 12px;
        border: solid #0C98FE;
        border-width: 0 2px 2px 0;
        -webkit-transform: rotate(45deg);
        -ms-transform: rotate(45deg);
        transform: rotate(45deg);
        position: absolute;
        top: -1px;
        left: 3px;
    }

    >>> input[type=checkbox].intermediate:before {
        border: 2px solid #6f6f6f;
        background-color: #9f9f9f;
    }

    >>> input[type=checkbox].intermediate:after {
        content: "";
        display: block;
        width: 16px;
        height: 3px;
        /*border: solid #fff;*/
        /*border-width: 0 2px 0 0;*/
        background-color: white;
        /*-webkit-transform: rotate(45deg);*/
        /*-ms-transform: rotate(45deg);*/
        /*transform: rotate(45deg);*/
        position: absolute;
        top: 4px;
        left: -2px;
        right: 0;
    }
    /** 셀렉트 체크박스 Style 종료 */

    .visibility-hidden {
        visibility: hidden !important;
    }

    /** 스크롤 성능 향상 로직(repaint 작업 감소) */
    >>> thead > tr > th {
        transform: translateZ(0);
    }

    >>> tbody > tr {
        transform: translateZ(0);
    }

    >>> .icon--container {
        display: flex;
        align-items: center;
        visibility: hidden;
    }

    >>> .icon--container > button:not(:first-child) {
        margin-left: 4px;
    }

    >>> tr:hover .icon--container {
        visibility: visible;
    }

    >>> .v-data-table.v-data-table--fixed-header thead th {
        cursor: default !important;
    }

    .v-data-table.v-data-table--fixed-header thead th {
        cursor: default !important;
    }

    .v-data-table-header th .active .v-data-table-header__icon {
        opacity: 1 !important;
    }

    >>> .v-data-table-header th .active .v-data-table-header__icon {
        opacity: 1 !important;
        color: rgb(0, 0, 0.87) !important;
    }

    >>> .vue-data-table__label {
        width: 8px;
        height: 100%;
    }
</style>
